import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ACCOUNT_URLS, ROUTE_URLS, SUPPORT_URLS } from '../app.routes.names';
import { RouterModule } from '@angular/router';
import { SHOPIFY_TOKENS } from '../../environments/environment';

@Component({
  selector: 'app-footer',
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  public SUPPORT_ROUTE_URLS = SUPPORT_URLS;
  public ROUTE_URLS = ROUTE_URLS;
  public ACCOUNT_URLS = ACCOUNT_URLS;
  public openedMenu: string;
  public currentYear = new Date().getFullYear();
  public footerGroups = [
    {
      title: 'Shop',
      links: [
        { label: 'All plans', href: `https://${SHOPIFY_TOKENS.domain}/collections/plans-monthly` },
        { label: 'Phones', href: `https://${SHOPIFY_TOKENS.domain}/collections/phones` },
        { label: 'Activate a SIM', href: `https://${SHOPIFY_TOKENS.domain}/pages/activate` }
      ]
    },
    {
      title: 'SpeakOut Wireless',
      links: [
        { label: 'Why SpeakOut Wireless', href: `https://${SHOPIFY_TOKENS.domain}/pages/why-speakout-wireless` },
        { label: 'Switch to SpeakOut Wireless', href:`https://${SHOPIFY_TOKENS.domain}/pages/switch` },
        { label: 'Coverage', href:`https://${SHOPIFY_TOKENS.domain}/pages/coverage` },
        { label: 'Deals', href: `https://${SHOPIFY_TOKENS.domain}/pages/deals`},
        { label: 'Account', href: `https://${SHOPIFY_TOKENS.domain}/account` },
        { label: 'Help center', href: `https://${SHOPIFY_TOKENS.domain}/pages/help` },
        { label: 'Support', href: `https://${SHOPIFY_TOKENS.domain}/pages/support` },
        { label: 'Text with 9-1-1', href: `https://${SHOPIFY_TOKENS.domain}/pages/text-9-1-1` },
        { label: 'Complaints', href: `https://${SHOPIFY_TOKENS.domain}/pages/complaints` },
        { label: 'Phone user guides', href: `https://${SHOPIFY_TOKENS.domain}/pages/phone-user-guides` },
        { label: 'Travelling to Canada?', href: `https://${SHOPIFY_TOKENS.domain}/pages/travellers` },
        { label: 'CRTC Wireless Code', href: `http://crtc.gc.ca/eng/phone/mobile/prepay.htm?linktype=footer&amp;INTCMP=TcomFooter_EN_prepay` }
      ]
    },
    {
      title: '7-Eleven',
      links: [
        { label: 'About 7-Eleven', href: `https://www.7-eleven.ca/about` },
        // { label: 'Merch (soon)', href: '#' },
        // { label: 'Gift cards (soon)', href: '#' },
        { label: 'Contact us', href: `https://${SHOPIFY_TOKENS.domain}/pages/contact`}
      ]
    }
  ];
  public copyRightFooterLinks = [
    {title: "Contact Us", href: `https://${SHOPIFY_TOKENS.domain}/pages/contact`},
    {title: "Sign Up", href: `https://${SHOPIFY_TOKENS.domain}/account`},
    {title: "About", href: `https://${SHOPIFY_TOKENS.domain}/pages/why-speakout-wireless`},
    {title: "Find A Store", href: `https://www.7-eleven.ca/locator`},
    {title: "Privacy", href: `https://${SHOPIFY_TOKENS.domain}/pages/privacy-policy`},
    {title: "Terms", href: `https://${SHOPIFY_TOKENS.domain}/pages/terms-of-service`}
  ]
  toggleMenu(name: string) {
    this.openedMenu = this.openedMenu == name ? '' : name;
  }
}
